export const DateData = [
    {
        id: 1,
        contactDate: "2022-04-26", 
        effectiveDate: "2022-04-30"
    },
    {
      id: 2,
      contactDate: "2022-02-05", 
      effectiveDate: "2022-02-25"
    },
    {
      id: 3,
      contactDate: "2022-04-19", 
      effectiveDate: "2022-04-29"
    },
    {
      id: 4,
      contactDate: "2022-05-01", 
      effectiveDate: "2022-05-20"
    },
    {
      id: 5,
      contactDate: "2021-11-01", 
      effectiveDate: "2021-11-20"
    },
  ];
  
